import warning from "../assets/svg/warning.svg";
import warningFilled from "../assets/svg/warning-filled.svg";
import { t } from "i18next";

type WarningProps = {
  fillIn?: boolean;
};

export const Warning = ({ fillIn = false }: WarningProps) => {
  return (
    <img
      src={fillIn ? warningFilled : warning}
      alt={t("core:common:warning") as string}
    />
  );
};
